import type { ReactNode } from 'react';

export const symbol_how_to_reg: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24.75 0-42.37-17.63Q80-195.25 80-220v-34q0-34 17-62.5t51-43.5q72-32 132-46t120-14q14 0 29 .75t27 2.25q12.12 1.55 20.56 11.64 8.44 10.08 6.44 22.5-2 10.86-11.5 18.36T450-358q-14-1-27-1.5t-23-.5q-58 0-105.5 10.5T172-306q-17 8-24.5 23t-7.5 29v34h319q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm485-68 192-192q9-9 21-9t21 9q9 9 9 21t-9 21L646-165q-9 9-21 9t-21-9l-99-99q-9-9-9-21t9-21q9-9 21-9t21 9l78 78ZM292-524q-42-42-42-108t42-108q42-42 108-42t108 42q42 42 42 108t-42 108q-42 42-108 42t-108-42Zm153 290Zm19.5-333.5Q490-593 490-632t-25.5-64.5Q439-722 400-722t-64.5 25.5Q310-671 310-632t25.5 64.5Q361-542 400-542t64.5-25.5ZM400-632Z"
		/>
	</svg>
);
